import React, { useState, useEffect } from 'react';
import './Suggestion.css';
import sendIcon3 from '../../Assets/Images/myuti-send-2.png';

const Suggestion = ({ text, sendMessage, setHome, index }) => {
  const [clicked, setClicked] = useState(false);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    setTimeout(() => setVisible(true), index * 300); // Delays each suggestion
  }, [index]);

  const isQuizzPrompt = text.includes('Take the Urinary Tract Health Quiz');

  const handleClick = () => {
    if (isQuizzPrompt) {
      // open the quiz from MyUTI directly, do not run the prompt message
      window.open('https://tinyurl.com/opinion-stage-quiz', '_blank');
      return;
    } else {
      if (!clicked) {
        sendMessage({ type: 'user', message: text });
        setClicked(true);
        setHome(false);
      }
    }
  };

  return (
    <div
      className="suggestion-wrapper"
      onClick={handleClick}
      style={{
        // animationDelay: `${index * 100}ms`,
        display: visible ? 'flex' : 'none', // Ensures it appears at the right time
      }}
    >
      <div className={`Suggestion ${clicked ? 'clicked' : ''}`}>{text}</div>
      <img
        style={{ width: 20, height: 20, marginLeft: 10 }}
        src={sendIcon3}
        alt="Send"
      />
    </div>
  );
};

export default Suggestion;
